import { createAxios } from "./axiosHttpMarconi";
export const ticketBaiService = {
  getConfig,
  registerConfig,
  deleteConfig,
};

function getConfig(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/franquicia/${id}/fiskaly/ticket-bai`;
  return axios.get(urlPath);
}

function registerConfig(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/franquicia/${id}/fiskaly/ticket-bai`;
  return axios.post(urlPath, body);
}

function deleteConfig(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/franquicia/${id}/fiskaly/ticket-bai`;
  return axios.delete(urlPath);
}
